/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Select_All_AfterInputs */



/**
* | output |
* | --- |
* | "Select All After" |
*
* @param {Context_Menu_Select_All_AfterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_select_all_after = /** @type {((inputs?: Context_Menu_Select_All_AfterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Select_All_AfterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner tout après")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle auswählen nach")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona tutto dopo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбрать все после")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar todo después")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择所有")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて選択後")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionar tudo depois")
	return /** @type {LocalizedString} */ ("Select All After")
});